import { render, staticRenderFns } from "./alertBox.vue?vue&type=template&id=18e11e0c"
import script from "./alertBox.vue?vue&type=script&lang=js"
export * from "./alertBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports